exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "table.calendar {\n  border-collapse: collapse;\n  border-spacing: 0;\n  width: 100%; }\n\ntable.calendar td {\n  border: none;\n  text-align: center; }\n\ntable.calendar thead tr {\n  height: 3.6rem;\n  border-bottom: 1px solid #E3E3E3; }\n\ntable.calendar thead th {\n  text-align: center; }\n\n.disable-day {\n  color: #d2d2d2;\n  cursor: default; }\n\n.day {\n  height: 30px;\n  padding-top: 5px;\n  width: 30px;\n  cursor: pointer;\n  color: #4c4c4c;\n  border-radius: 50px;\n  margin-left: auto;\n  margin-right: auto;\n  transition: all .3s ease-in-out; }\n\n.selected-date {\n  transform: scale(1.7);\n  color: #3F51B5; }\n\n.day:hover {\n  transform: scale(1.7);\n  color: #3F51B5; }\n\n.attendance-status-red {\n  height: 4px;\n  width: 4px;\n  border: 1px solid red;\n  border-radius: 10px;\n  margin-left: auto;\n  margin-right: auto;\n  background-color: red; }\n\n.attendance-status-green {\n  height: 4px;\n  width: 4px;\n  border: 1px solid green;\n  border-radius: 10px;\n  margin-left: auto;\n  margin-right: auto;\n  background-color: green; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/olr-directives/styles/index.scss
 ** module id = 90
 ** module chunks = 1
 **/